export default function detectBrowserRefresh() {
  if (typeof window === "undefined") {
    return undefined;
  }

  // relevant documentation on API https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming/type
  const [perfNavigationTiming] = window.performance.getEntriesByType("navigation");

  if (perfNavigationTiming) {
    return perfNavigationTiming.entryType === "navigation";
  }
  return undefined;
}
